module.exports = __webpack_public_path__ + "img/portraits_02_V.5e405c4f.jpg";